<style scoped>
h2,
h4 {
  text-align: center;
}
th.title {
  background-color: #26304d;
  color: #ffffff;
  text-align: left;
}
.container {
  margin: 20px auto;
}
.section {
  width: 80%;
  margin: auto;
}
table tr td,
table tr th {
  border: 1px solid #000000;
  padding: 5px;
}
.spacer {
  padding: 15px;
}
#customerLabel {
  margin-bottom: 40px;
}
.caption {
  font-weight: bold;
}
.terms {
  height: 200px;
  overflow-y: scroll;
  border: 1px solid #eeeeee;
  text-align: left;
  margin-bottom: 10px;
  background-color: whitesmoke;
}
.terms p,
p {
  font-size: 14px;
}
.radio {
  margin: auto;
  width: 20%;
}

@media print {
  * {
    font-size: 10px;
  }
  .g-bg-main {
    display: none;
  }
  .section {
    width: auto;
  }
  #customerLabel {
    margin-bottom: 35px;
  }
  .spacer {
    padding: 1px;
  }
  template {
    margin: 0px;
    padding: 0px;
  }
  #btnPrint {
    display: none;
  }
  h2,
  h4,
  p {
    font-size: 12px;
  }
  .terms {
    height: auto;
    border: 1px solid #eeeeee;
    text-align: left;
    margin-bottom: 10px;
  }
}
</style>
<template>
    <div>
        <div class="g-bg-main">
            <router-link :to=" {name: 'Home'}">
                <img src="/static/assets/img/logo/OSEL Foundation_white_vertical.png" class="evf_logo">
            </router-link>
            <div class="container g-py-15">
            </div>
        </div>
        <div>
            <div class="container">
                <div class="section">
                    <input type="button" class="btn u-shadow-v33 g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-px-25 g-py-5" id="btnPrint" onclick="javascript: window.print()" value="Print Form" />
                </div>
                <div class="section g-my-20">
                    <h4 v-if="Account.accountType == 1">INDIVIDUAL REGISTRATION DETAILS</h4>
                    <h4 v-if="Account.accountType == 2">PRACTICE/BUSINESS REGISTRATION DETAILS</h4>
                    <h4 v-if="Account.accountType == 3">NON-PROFIT REGISTRATION DETAILS</h4>
                </div>
                <div class="section">
                    <table>
                        <tbody>
                            <tr>
                                <th colspan="6" class="title">Username and Password</th>
                            </tr>
                            <tr>
                                <td class="caption">Email Address</td>
                                <td colspan="5">{{Account.emailAddress}}</td>
                            </tr>
                            <tr>
                                <th colspan="6" class="title">Participant Information</th>
                            </tr>
                            <tr v-if="Account.accountType == 1 && !Account.useLicenseNumber">
                                <td class="caption">NPI Number</td>
                                <td colspan="5">{{Account.npiNumber}}</td>
                            </tr>
                            <tr v-if="Account.accountType == 1 && Account.useLicenseNumber">
                                <td class="caption">License Number</td>
                                <td colspan="5">{{Account.licenseNumber}}</td>
                            </tr>
                            <tr v-if="Account.accountType == 1 || Account.accountType == 2">
                                <td class="caption">Participant First Name</td>
                                <td>{{Account.primaryContact.firstName}}</td>
                                <td class="caption">Participant Last Name</td>
                                <td>{{Account.primaryContact.lastName}}</td>
                                <td class="caption">Suffix</td>
                                <td>{{Account.primaryContact.suffix}}</td>
                            </tr>
                            <tr v-if="Account.accountType == 3">
                                <td class="caption">Primary Contact First Name</td>
                                <td>{{Account.primaryContact.firstName}}</td>
                                <td class="caption">Primary Contact Last Name</td>
                                <td>{{Account.primaryContact.lastName}}</td>
                                <td class="caption">Suffix</td>
                                <td>{{Account.primaryContact.suffix}}</td>
                            </tr>
                            <tr v-if="Account.accountType == 1">
                                <td class="caption">Participant Phone Number</td>
                                <td>({{Account.primaryContact.countryCode}}) {{Account.primaryContact.areaCode}}-{{Account.primaryContact.phone}}</td>
                                <td class="caption">Year Licensed</td>
                                <td>{{Account.primaryContact.yearsInPractice}}</td>
                                <td class="caption">Business Type</td>
                                <td>{{Account.primaryContact.businessTypeDesc}}</td>
                            </tr>
                            <tr v-if="Account.accountType == 2">
                                <td class="caption">Participant Phone Number</td>
                                <td>({{Account.primaryContact.countryCode}}) {{Account.primaryContact.areaCode}}-{{Account.primaryContact.phone}}</td>
                                <td class="caption">Legal Business Name</td>
                                <td colspan="3">{{Account.primaryContact.legalName}}</td>
                            </tr>
                            <tr v-if="Account.accountType == 3">
                                <td class="caption">Participant Phone Number</td>
                                <td>({{Account.primaryContact.countryCode}}) {{Account.primaryContact.areaCode}}-{{Account.primaryContact.phone}}</td>
                                <td class="caption">Legal Organization Name (Participant)</td>
                                <td colspan="3">{{Account.primaryContact.legalName}}</td>
                            </tr>
                            <tr v-if="Account.accountType == 2">
                                <td class="caption">Business Type</td>
                                <td>{{Account.primaryContact.businessTypeDesc}}</td>
                                <td class="caption">Role in Business</td>
                                <td colspan="3">{{Account.primaryContact.titleDesc}}</td>
                            </tr>
                            <tr v-if="Account.accountType == 3">
                                <td class="caption">Organization Type</td>
                                <td>{{Account.primaryContact.businessTypeDesc}}</td>
                                <td class="caption">Role in Organization</td>
                                <td colspan="3">{{Account.primaryContact.titleDesc}}</td>
                            </tr>
                            <tr>
                                <th colspan="6" class="title" v-if="Account.accountType == 1">Shipping Information</th>
                                <th colspan="6" class="title" v-if="Account.accountType == 2">Office Location Information</th>
                                <th colspan="6" class="title" v-if="Account.accountType == 3">Chapter Location Information</th>
                            </tr>
                            <tr v-if="Account.accountType == 2 && Account.primaryContact.isMultiLocation">
                                <td class="caption">Office Location Name</td>
                                <td colspan="5">{{Account.primaryContact.officeLocation.name}}</td>
                            </tr>
                            <tr>
                                <td class="caption">Street Address</td>
                                <td colspan="3">{{Account.primaryContact.officeLocation.streetAddress}}</td>
                                <td class="caption">Suite</td>
                                <td>{{Account.primaryContact.officeLocation.suite}}</td>
                            </tr>
                            <tr>
                                <td class="caption">City</td>
                                <td>{{Account.primaryContact.officeLocation.city}}</td>
                                <td class="caption">State</td>
                                <td>{{Account.primaryContact.officeLocation.state}}</td>
                                <td class="caption">Zip Code</td>
                                <td>{{Account.primaryContact.officeLocation.zip}}</td>
                            </tr>
                            <tr v-if="(Account.accountType == 2 || Account.accountType == 3) && !Account.primaryContact.isMultiLocation">
                                <td class="caption">Phone Number</td>
                                <td colspan="5">{{Account.primaryContact.officeLocation.countryCode}} - {{Account.primaryContact.officeLocation.areaCode}} - {{Account.primaryContact.officeLocation.phoneNumber}}</td>
                            </tr>
                            <tr v-if="Account.accountType == 2 && Account.primaryContact.isMultiLocation">
                                <td class="caption">Phone Number</td>
                                <td>{{Account.primaryContact.officeLocation.countryCode}} - {{Account.primaryContact.officeLocation.areaCode}} - {{Account.primaryContact.officeLocation.phoneNumber}}</td>
                                <td class="caption">Email Address</td>
                                <td colspan="3">{{Account.primaryContact.officeLocation.emailAddress}}</td>
                            </tr>
                            <tr v-if="Account.accountType == 2 && Account.primaryContact.isMultiLocation">
                                <td class="caption">Office Contact First Name</td>
                                <td>{{Account.primaryContact.officeLocation.contactFirstName}}</td>
                                <td class="caption">Office Contact Last Name</td>
                                <td colspan="3">{{Account.primaryContact.officeLocation.contactLastName}}</td>
                            </tr>
                            <tr v-if="Account.accountType == 2 && Account.primaryContact.isMultiLocation">
                                <td class="caption">Role in Business</td>
                                <td colspan="5">{{Account.primaryContact.officeLocation.contactRoleDesc}}</td>
                            </tr>
                            <tr>
                                <td class="caption" colspan="5">Number of charitable orders this calendar year:</td>
                                <td>{{Account.primaryContact.officeLocation.numberOfJobs}}</td>
                            </tr>
                            <tr>
                                <th>Jan</th>
                                <th>Feb</th>
                                <th>Mar</th>
                                <th>Apr</th>
                                <th>May</th>
                                <th>Jun</th>
                            </tr>
                            <tr>
                                <td>{{ Account.primaryContact.officeLocation.jobs.january }}</td>
                                <td>{{ Account.primaryContact.officeLocation.jobs.february }}</td>
                                <td>{{ Account.primaryContact.officeLocation.jobs.march }}</td>
                                <td>{{ Account.primaryContact.officeLocation.jobs.april }}</td>
                                <td>{{ Account.primaryContact.officeLocation.jobs.may }}</td>
                                <td>{{ Account.primaryContact.officeLocation.jobs.june }}</td>
                            </tr>
                            <tr>
                                <th>Jul</th>
                                <th>Aug</th>
                                <th>Sep</th>
                                <th>Oct</th>
                                <th>Nov</th>
                                <th>Dec</th>
                            </tr>
                            <tr>
                                <td>{{ Account.primaryContact.officeLocation.jobs.july }}</td>
                                <td>{{ Account.primaryContact.officeLocation.jobs.august }}</td>
                                <td>{{ Account.primaryContact.officeLocation.jobs.september }}</td>
                                <td>{{ Account.primaryContact.officeLocation.jobs.october }}</td>
                                <td>{{ Account.primaryContact.officeLocation.jobs.november }}</td>
                                <td>{{ Account.primaryContact.officeLocation.jobs.december }}</td>
                            </tr>
                            <tr v-if="Account.accountType == 2 || Account.accountType == 3">
                                <th colspan="6" class="title">Eye Doctor Information</th>
                            </tr>
                            <tr v-if="Account.accountType == 2 || Account.accountType == 3" v-for="item in Account.eyeDoctors">
                                <td colspan="6">
                                    <table style="margin-left:0px;width:100%">
                                        <tr>
                                            <td class="caption">NPI Number</td>
                                            <td colspan="5">{{item.npiNumber}}</td>
                                        </tr>
                                        <tr>
                                            <td class="caption" style="width:25%;">Doctor's First Name</td>
                                            <td style="width:25%;">{{item.firstName}}</td>
                                            <td class="caption" style="width:25%;">Doctor's Last Name</td>
                                            <td style="width:25%;">{{item.lastName}}</td>
                                            <td class="caption">Suffix</td>
                                            <td>{{item.suffix}}</td>
                                        </tr>
                                        <tr>
                                            <td class="caption" style="width:25%;">Doctor's Email Address</td>
                                            <td style="width:25%;">{{item.emailAddress}}</td>
                                            <td class="caption" style="width:25%;">Year Licensed</td>
                                            <td style="width:25%;" colspan="3">{{item.yearsInPractice}}</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <th colspan="6" class="title" v-if="Account.accountType == 1 || Account.accountType == 2">Association Information and Communication Preferences</th>
                                <th colspan="6" class="title" v-if="Account.accountType == 3">Communication Preferences</th>
                            </tr>
                            <tr v-if="Account.accountType != 3">
                                <td class="caption" colspan="2">Professional Organizations</td>
                                <td colspan="4">
                                    <ul v-for="orgItem in Account.organizations.list">
                                        <li>{{ orgItem }}</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td class="caption" colspan="2">Communication Preferences</td>
                                <td colspan="4">
                                    <input type="checkbox" v-model="Account.toBeContactedAsVolunteer" disabled /> I would like to be contacted if there are volunteer opportunities in my area.<br/>
                                    <input type="checkbox" v-model="Account.toReceiveNewsLetter" disabled /> I would like email updates from OneSight EssilorLuxottica Foundation.
                                </td>
                            </tr>
                            <tr>
                                <th colspan="6" class="title" v-if="Account.isCoveredUnderHIPAA">Terms & Conditions and BAA</th>
                                <th colspan="6" class="title" v-else>Terms & Conditions</th>
                            </tr>
                            <tr>
                                <td colspan="6">
                                    <p>
                                        This Agreement (“Contract”) consists of the following Terms and Conditions and referenced Business Associate Agreement. Please review and accept both documents in order to proceed with participation. If you have any questions, click here to contact us. <br>
                                    </p>
                                    <p style="font-weight:bold; text-align:left;">
                                        Terms and Conditions
                                    </p>
                                    <p>
                                        Please review and accept the below Terms and Conditions.
                                    </p>
                                    <div class="terms">
                                        <p>
                                            Lorem ipsum dolor sit amet, veniam numquam has te. No suas nonumes recusabo mea, est ut graeci definitiones. His ne melius vituperata scriptorem, cum paulo copiosae conclusionemque at. Facer inermis ius in, ad brute nominati referrentur vis. Dicat erant sit ex. Phaedrum imperdiet scribentur vix no, ad latine similique forensibus vel.
                                        </p>
                                        <p>
                                            Dolore populo vivendum vis eu, mei quaestio liberavisse ex. Electram necessitatibus ut vel, quo at probatus oportere, molestie conclusionemque pri cu. Brute augue tincidunt vim id, ne munere fierent rationibus mei. Ut pro volutpat praesent qualisque, an iisque scripta intellegebat eam.
                                        </p>
                                        <p>
                                            Mea ea nonumy labores lobortis, duo quaestio antiopam inimicus et. Ea natum solet iisque quo, prodesset mnesarchum ne vim. Sonet detraxit temporibus no has. Omnium blandit in vim, mea at omnium oblique.
                                        </p>
                                        <p>
                                            Eum ea quidam oportere imperdiet, facer oportere vituperatoribus eu vix, mea ei iisque legendos hendrerit. Blandit comprehensam eu his, ad eros veniam ridens eum. Id odio lobortis elaboraret pro. Vix te fabulas partiendo.
                                        </p>
                                        <p>
                                            Natum oportere et qui, vis graeco tincidunt instructior an, autem elitr noster per et. Mea eu mundi qualisque. Quo nemore nusquam vituperata et, mea ut abhorreant deseruisse, cu nostrud postulant dissentias qui. Postea tincidunt vel eu.
                                        </p>
                                        <p>
                                            Ad eos alia inermis nominavi, eum nibh docendi definitionem no. Ius eu stet mucius nonumes, no mea facilis philosophia necessitatibus. Te eam vidit iisque legendos, vero meliore deserunt ius ea. An qui inimicus inciderint.
                                        </p>
                                    </div>
                                    <p style="font-weight:bold; text-align:left;">Participant Responsibilities:</p>
                                    <p>
                                        Please review and select each of the following responsibilities (from the above Terms and Conditions) to confirm your agreement: Please note, you will not be able to submit the form if you do not click "I Agree" beneath each item.
                                    </p>
                                    <p>
                                        Participant agrees to co-brand and promote Essilor Vision Foundation as a charitable partner, specifically, but not limited to Essilor Vision Foundation logo included on Participant Program Materials and agrees to submit to Essilor Vision Foundation, any requests for additional trademarks, copy or content needed for individual events or media for Essilor Vision Foundation’s approval prior to publication
                                    </p>
                                    <p>
                                        Participant agrees to commit to the use of the ECP Portal and lenses for charitable vision services
                                    </p>
                                    <p>
                                        Participant agrees to validate the patient need through an indirect referral network or directly through vetting by the Participant which shall include: income below poverty level, lack of insurance and/or lack of lens benefit
                                    </p>
                                    <p>
                                        Participant agrees to ensure that no charge is accepted or marketed, specific to the lens product delivered; however, Participant is able to charge up to, but not to exceed, the cost of the frame when there is a cost associated with the frame
                                    </p>
                                    <p>
                                        Participant agrees to retain an electronic log outlining to whom Essilor Vision Foundation services were provided. Information may include, but is not limited to: date of service, number/name of patient examined with validation of need, number of exams, number of patients who received glasses, total number of glasses dispensed, and number of patients receiving glasses for the first time. The electronic log must be kept available during the term of the Contract for audit purposes and other treatment and health care operation purposes further described in the accompanying BAA, as Essilor Vision Foundation may request from time to time during the Term.
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td class="caption" colspan="2">Participant Responsibilities Signature</td>
                                <td>{{Account.participantResponsibilitiesSignature}}</td>
                                <td class="caption" colspan="2">Date Signed</td>
                                <td>{{ FormatDate(Account.participantResponsibilitiesDate) }}</td>
                            </tr>
                            <tr v-if="Account.isCoveredUnderHIPAA">
                                <td colspan="6">
                                    <p style="font-weight:bold; text-align:left;">
                                        Business Associate Agreement
                                    </p>
                                    <p>
                                        Please review and accept the terms of the below Business Associate Agreement.
                                    </p>
                                    <div class="terms">
                                        <p>
                                            Lorem ipsum dolor sit amet, veniam numquam has te. No suas nonumes recusabo mea, est ut graeci definitiones. His ne melius vituperata scriptorem, cum paulo copiosae conclusionemque at. Facer inermis ius in, ad brute nominati referrentur vis. Dicat erant sit ex. Phaedrum imperdiet scribentur vix no, ad latine similique forensibus vel.
                                        </p>
                                        <p>
                                            Dolore populo vivendum vis eu, mei quaestio liberavisse ex. Electram necessitatibus ut vel, quo at probatus oportere, molestie conclusionemque pri cu. Brute augue tincidunt vim id, ne munere fierent rationibus mei. Ut pro volutpat praesent qualisque, an iisque scripta intellegebat eam.
                                        </p>
                                        <p>
                                            Mea ea nonumy labores lobortis, duo quaestio antiopam inimicus et. Ea natum solet iisque quo, prodesset mnesarchum ne vim. Sonet detraxit temporibus no has. Omnium blandit in vim, mea at omnium oblique.
                                        </p>
                                        <p>
                                            Eum ea quidam oportere imperdiet, facer oportere vituperatoribus eu vix, mea ei iisque legendos hendrerit. Blandit comprehensam eu his, ad eros veniam ridens eum. Id odio lobortis elaboraret pro. Vix te fabulas partiendo.
                                        </p>
                                        <p>
                                            Natum oportere et qui, vis graeco tincidunt instructior an, autem elitr noster per et. Mea eu mundi qualisque. Quo nemore nusquam vituperata et, mea ut abhorreant deseruisse, cu nostrud postulant dissentias qui. Postea tincidunt vel eu.
                                        </p>
                                        <p>
                                            Ad eos alia inermis nominavi, eum nibh docendi definitionem no. Ius eu stet mucius nonumes, no mea facilis philosophia necessitatibus. Te eam vidit iisque legendos, vero meliore deserunt ius ea. An qui inimicus inciderint.
                                        </p>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="Account.isCoveredUnderHIPAA">
                                <td class="caption" colspan="2">Business Associate Agreement Signature</td>
                                <td>{{ Account.businessAssociateAgreementSignature }}</td>
                                <td class="caption" colspan="2">Date Signed</td>
                                <td>{{ FormatDate(Account.businessAssociateAgreementDate) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <input type="button" onclick="javascript: window.print()" value="Print" /> -->
            </div>
        </div>
    </div>
</template>

<script>
function InitialData() {
  return {
    Account: {}
  };
}
import HeaderComponent from "@/components/shared/HeaderComponent";
import FooterComponent from "@/components/shared/FooterComponent";
export default {
  components: { HeaderComponent, FooterComponent },
  data() {
    return InitialData();
  },
  mounted: function() {
    this.GetAccountById(this.$route.query.salesforceId); //method1 will execute at pageload
  },
  methods: {
    GetAccountById(salesforceId) {
      var _this = this;

      axios
        .get("/Account/GetBySalesforceId/" + salesforceId, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        })
        .then(function(response) {
          _this.Account = response.data.raw;
        })
        .catch(function(error) {
          console.log(error);
          _this.$router.push({name: 'Error'});
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// RegistrationSummary.vue?7637adb0